// 登录des对称加密
// @ts-ignore
import CryptoJs from 'crypto-js';

export const AESFunction = {
  /**
   * 加密
   */
  encrypt(word: string) {
    const key = CryptoJs.enc.Utf8.parse('i4pbERfeQKB2DM7R');
    const srcs = CryptoJs.enc.Utf8.parse(word);
    // 如果要用AES加密，就将下面这行DES改成AES 解密同理
    const encrypted = CryptoJs.AES.encrypt(srcs, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return encrypted.toString();
  },

  /**
   * 解密
   */
  decrypt(word: string) {
    const key = CryptoJs.enc.Utf8.parse('i4pbERfeQKB2DM7R');
    // 如果要用AES解密，就将下面这行DES改成AES 加密同理
    const decrypt = CryptoJs.AES.decrypt(word, key, {
      mode: CryptoJs.mode.ECB,
      padding: CryptoJs.pad.Pkcs7
    });
    return CryptoJs.enc.Utf8.stringify(decrypt).toString();
  }
};
